<template lang="pug">
.store
  .store__menu
    Tabs(
      :items='tabs',
      :active-tab-index='activeTabIndex',
      @change='onTabChange'
    )
  .page__content
    //.page__section(v-if="tabIs('subscriptions')")
    //  SectionTitle {{ $t('moreSubscriptionsSoon') }}
    //
    //  .store__list.store__subscriptions
    //    .store__product
    //      VVVPass(:subscription="trialSubscription" :user-subscriptions="subscriptions" is-trial @buy="onBuySubscriptionClickAction")
    //      // Nolimit(:duration="30" :subscriptions="subscriptionsFreerollMonthly" :star-products="starProductsMonthly" :user-subscriptions="subscriptions" @showInfo="onBuySubscriptionClickAction" @buy="onBuySubscriptionClickAction")
    //    .store__product
    //      VVVPass(:subscription="seasonSubscription" :user-subscriptions="subscriptions" @buy="onBuySubscriptionClickAction")
    //      // Nolimit(:duration="7" :subscriptions="subscriptionsFreerollWeekly" :star-products="starProductsWeekly" :user-subscriptions="subscriptions" @showInfo="onBuySubscriptionClickAction" @buy="onBuySubscriptionClickAction")

    .page__section(v-if="tabIs('marketplace')")
      SectionTitle {{ $t("marketplace") }}

      .store__marketplace(v-if="marketplaceProducts")
        .store__marketplace-filters
          BaseSelect(
            :options="productTypes"
            :value="productType"
            :with-empty-value="true"
            :placeholder="$t('productType')"
            @input="onProductTypeChange($event)"
          )
            span {{ productType }}
          BaseSelect(
            :options="brandsSorted"
            :value="brand"
            :with-empty-value="true"
            :placeholder="$t('brand')"
            @input="onBrandChange($event)"
          )
            span {{ productType }}
          BaseSelect(
            :options="sorts"
            :value="sort"
            :with-empty-value="true"
            :placeholder="$t('sort')"
            @input="onSortChange($event)"
          )
            span {{ productType }}
          .store__marketplace-filter
            CheckboxInput(v-model="checkboxInStore")
            span {{ $t("inStock") }}

        .store__marketplace-list
          .store__marketplace-product(v-for="mpItem in marketplaceProducts" :key="mpItem.id" @click="openMarketplaceProduct(mpItem)")
            img.store__marketplace-product-image(v-if="mainImage(mpItem)" :src="mainImage(mpItem)" alt="cover")
            .store__marketplace-product-image(v-else)
            .store__marketplace-product-body
              .store__marketplace-product-body-brand {{ mpItem.brand }}
              .store__marketplace-product-body-title {{ mpItem.title }}
              Currency.store__marketplace-product-body-right(type="money" is-reversed size="16" real)
                span.store__marketplace-product-body-price {{ $t('upTo') }} {{ (mpItem.max_price / 100).toFixed(2).replace('.00', '') }}
        Pagination(
          v-if="marketplaceProducts && marketplaceProducts.length"
          :per-page="marketplaceProductsPageSize"
          :pages-count="marketplaceProductsPagesCount"
          :current-page="marketplaceProductsPage - 1"
          @perPageChange="onMarketplaceProductsPerPageChange"
          @pageChange="onMarketplaceProductsPageChange"
        )
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs'
import Pagination from '~/components/Pagination/Pagination'
import Tabs from '~/components/Tabs/Tabs'
import BaseSelect from '~/components/BaseSelect/BaseSelect'
import CheckboxInput from '~/components/CheckboxInput/CheckboxInput'
// import Nolimit from '~/components/Subscription/Nolimit'
import VVVPass from '~/components/Subscription/VVVPass'
import DeviceCard from '~/components/StoreCard/DeviceCard'
import ProxyCard from '~/components/StoreCard/ProxyCard'
import FreebetCard from '~/components/StoreCard/FreebetCard'
import StoreService from '~/services/StoreService'

export default {
  name: 'PageStore',

  components: {
    Breadcrumbs,
    Pagination,
    Tabs,
    // Nolimit,
    VVVPass,
    DeviceCard,
    ProxyCard,
    FreebetCard,
    BaseSelect,
    CheckboxInput
  },

  async asyncData ({ $axios }) {
    let storeProducts = []

    try {
      const { data } = await StoreService.getProducts($axios)
      storeProducts = data.data
    } catch (e) {
      console.log(e)
    }

    storeProducts = storeProducts.map((product) => {
      product.amount = product.extra_data.amount
      if (!product.extra_data.price_in_coins) {
        product.price /= 100
      }
      product.quantity = product.extra_data.quantity || 1
      return product
    })

    return {
      storeProducts
    }
  },

  data () {
    return {
      marketplaceProducts: undefined,
      marketplaceProductsPage: 1,
      marketplaceProductsPageSize: 12,
      marketplaceProductsCount: 0,
      gamesCurrenciesGames: [],
      breadcrumbs: [
        {
          title: 'VVV Store'
        }
      ],
      tabs: [
        // {
        //   id: 3,
        //   title: this.$t('subscriptions'),
        //   link: '/store/subscriptions'
        // },
        {
          id: 1000,
          title: this.$t('marketplace'),
          link: '/store/marketplace'
        }
      ],
      productTypes: [
        {
          value: 'Pre-Order',
          title: 'Pre-Order'
        },
        {
          value: 'Collectibles and Accessories',
          title: 'Collectibles and Accessories'
        },
        {
          value: 'Devices',
          title: 'Devices'
        },
        {
          value: 'Mousepads',
          title: 'Mousepads'
        },
        {
          value: 'Home & Office',
          title: 'Home & Office'
        },
        {
          value: 'Apparel',
          title: 'Apparel'
        },
        {
          value: 'On-Demand',
          title: 'On-Demand'
        },
        {
          value: 'Gaming chairs',
          title: 'Gaming chairs'
        },
        {
          value: 'Other',
          title: 'Other'
        }
      ],
      productType: '',
      brands: [
        {
          value: 'Demon Slayer: Kimetsu no Yaiba',
          title: 'Demon Slayer: Kimetsu no Yaiba'
        }, {
          value: 'Court Of The Dead',
          title: 'Court Of The Dead'
        }, {
          value: 'Evil Geniuses',
          title: 'Evil Geniuses'
        }, {
          value: 'PUBG',
          title: 'PUBG'
        }, {
          value: 'One Punch Man',
          title: 'One Punch Man'
        }, {
          value: 'Sd Gundam',
          title: 'Sd Gundam'
        }, {
          value: 'E.T. & Elliot',
          title: 'E.T. & Elliot'
        }, {
          value: 'SOULCALIBUR',
          title: 'SOULCALIBUR'
        }, {
          value: 'GAME OF THRONES',
          title: 'GAME OF THRONES'
        }, {
          value: 'One piece',
          title: 'One piece'
        }, {
          value: 'Fight Club',
          title: 'Fight Club'
        }, {
          value: 'Terminator 2',
          title: 'Terminator 2'
        }, {
          value: 'Ayrton Senna',
          title: 'Ayrton Senna'
        }, {
          value: 'Spyro the Drago',
          title: 'Spyro the Drago'
        }, {
          value: 'Bottom-Tier Character Tomozaki',
          title: 'Bottom-Tier Character Tomozaki'
        }, {
          value: 'Stranger Things',
          title: 'Stranger Things'
        }, {
          value: 'Aladdin',
          title: 'Aladdin'
        }, {
          value: 'The Mandalorian',
          title: 'The Mandalorian'
        }, {
          value: 'Batman',
          title: 'Batman'
        }, {
          value: 'Kaguya-Sama: Love Is War',
          title: 'Kaguya-Sama: Love Is War'
        }, {
          value: 'Ghostbusters',
          title: 'Ghostbusters'
        }, {
          value: 'La Reine des Neiges',
          title: 'La Reine des Neiges'
        }, {
          value: 'Ori and the Will of the Wisps',
          title: 'Ori and the Will of the Wisps'
        }, {
          value: 'Meta Merch',
          title: 'Meta Merch'
        }, {
          value: 'The Idolmaster',
          title: 'The Idolmaster'
        }, {
          value: 'A Certain Scientific Railgun T',
          title: 'A Certain Scientific Railgun T'
        }, {
          value: 'Razer',
          title: 'Razer'
        }, {
          value: 'Doctor Strange',
          title: 'Doctor Strange'
        }, {
          value: 'La Belle et la Bete',
          title: 'La Belle et la Bete'
        }, {
          value: 'Hearthstone',
          title: 'Hearthstone'
        }, {
          value: 'Jurassic Park',
          title: 'Jurassic Park'
        }, {
          value: 'Marvel',
          title: 'Marvel'
        }, {
          value: 'POKEMON',
          title: 'POKEMON'
        }, {
          value: 'Tomb Raider',
          title: 'Tomb Raider'
        }, {
          value: 'Deadpool',
          title: 'Deadpool'
        }, {
          value: 'Alien',
          title: 'Alien'
        }, {
          value: 'Nigma',
          title: 'Nigma'
        }, {
          value: 'Overwatch',
          title: 'Overwatch'
        }, {
          value: 'THE LAST OF US',
          title: 'THE LAST OF US'
        }, {
          value: 'Catwoman',
          title: 'Catwoman'
        }, {
          value: 'Avengers',
          title: 'Avengers'
        }, {
          value: 'Naruto',
          title: 'Naruto'
        }, {
          value: 'DISNEY',
          title: 'DISNEY'
        }, {
          value: 'Diablo',
          title: 'Diablo'
        }, {
          value: 'Shaman king',
          title: 'Shaman king'
        }, {
          value: 'Jojo\'s Bizarre Adventure',
          title: 'Jojo\'s Bizarre Adventure'
        }, {
          value: 'Harry Potter',
          title: 'Harry Potter'
        }, {
          value: 'Superman',
          title: 'Superman'
        }, {
          value: 'GOBLIN SLAYER',
          title: 'GOBLIN SLAYER'
        }, {
          value: 'Dark Crystal',
          title: 'Dark Crystal'
        }, {
          value: 'Star Wars',
          title: 'Star Wars'
        }, {
          value: 'Wonder Woman',
          title: 'Wonder Woman'
        }, {
          value: 'Evangelion: New Theatrical Edition',
          title: 'Evangelion: New Theatrical Edition'
        }, {
          value: 'Alita',
          title: 'Alita'
        }, {
          value: 'Power Rangers',
          title: 'Power Rangers'
        }, {
          value: 'Sonic',
          title: 'Sonic'
        }, {
          value: 'Thor',
          title: 'Thor'
        }, {
          value: 'Wolverine',
          title: 'Wolverine'
        }, {
          value: 'Black Widow',
          title: 'Black Widow'
        }, {
          value: 'Rick & Morty',
          title: 'Rick & Morty'
        }, {
          value: 'Mortal Kombat',
          title: 'Mortal Kombat'
        }, {
          value: 'The Joker',
          title: 'The Joker'
        }, {
          value: 'ANIMAJOR',
          title: 'ANIMAJOR'
        }, {
          value: 'Assassin\'s Creed: Animus',
          title: 'Assassin\'s Creed: Animus'
        }, {
          value: 'Borderlands 3',
          title: 'Borderlands 3'
        }, {
          value: 'SK Gaming',
          title: 'SK Gaming'
        }, {
          value: 'Warner Bros',
          title: 'Warner Bros'
        }, {
          value: 'World of Warcraft',
          title: 'World of Warcraft'
        }, {
          value: 'Sailor Moon',
          title: 'Sailor Moon'
        }, {
          value: 'Star Craft',
          title: 'Star Craft'
        }, {
          value: 'Gremlins',
          title: 'Gremlins'
        }, {
          value: 'World of Tanks',
          title: 'World of Tanks'
        }, {
          value: 'It Pennywise',
          title: 'It Pennywise'
        }, {
          value: 'HyperX',
          title: 'HyperX'
        }, {
          value: 'Corsair',
          title: 'Corsair'
        }, {
          value: 'Universal Monsters',
          title: 'Universal Monsters'
        }, {
          value: 'Call of Duty',
          title: 'Call of Duty'
        }, {
          value: 'That Time I Got Reincarnated as a Slime',
          title: 'That Time I Got Reincarnated as a Slime'
        }, {
          value: 'The Witcher 3',
          title: 'The Witcher 3'
        }, {
          value: 'Navi',
          title: 'Navi'
        }, {
          value: 'Weta Workshop',
          title: 'Weta Workshop'
        }, {
          value: 'The Elder Scrolls Online',
          title: 'The Elder Scrolls Online'
        }, {
          value: 'Fallout',
          title: 'Fallout'
        }, {
          value: 'Evangelion',
          title: 'Evangelion'
        }, {
          value: 'Re:ZERO - Starting Life in Another World',
          title: 'Re:ZERO - Starting Life in Another World'
        }, {
          value: 'Logitech',
          title: 'Logitech'
        }, {
          value: 'DC Comics',
          title: 'DC Comics'
        }, {
          value: 'Planet of the Apes',
          title: 'Planet of the Apes'
        }, {
          value: 'Cardcaptor Sakura: Clow Card',
          title: 'Cardcaptor Sakura: Clow Card'
        }, {
          value: 'X-men',
          title: 'X-men'
        }, {
          value: 'XPG',
          title: 'XPG'
        }, {
          value: 'Assassin\'s Creed',
          title: 'Assassin\'s Creed'
        }, {
          value: 'Harley Quinn',
          title: 'Harley Quinn'
        }, {
          value: 'Elder Scrolls V: Skyrim',
          title: 'Elder Scrolls V: Skyrim'
        }, {
          value: 'SteelSeries',
          title: 'SteelSeries'
        }, {
          value: 'Bruce Lee',
          title: 'Bruce Lee'
        }, {
          value: 'Vocaloid',
          title: 'Vocaloid'
        }, {
          value: 'Jujutsu Kaisen',
          title: 'Jujutsu Kaisen'
        }, {
          value: 'DOOM',
          title: 'DOOM'
        }, {
          value: 'Michael Jackson',
          title: 'Michael Jackson'
        }, {
          value: 'The Hobbit',
          title: 'The Hobbit'
        }, {
          value: 'Apex Legends',
          title: 'Apex Legends'
        }, {
          value: 'Elvis Presley',
          title: 'Elvis Presley'
        }, {
          value: 'League of Legends',
          title: 'League of Legends'
        }, {
          value: 'The Lord of the Rings Trilogy',
          title: 'The Lord of the Rings Trilogy'
        }, {
          value: 'Twisted Metal',
          title: 'Twisted Metal'
        }, {
          value: 'Dota2',
          title: 'Dota2'
        }, {
          value: 'Dragon Ball',
          title: 'Dragon Ball'
        }, {
          value: 'Captain America',
          title: 'Captain America'
        }, {
          value: 'Banjo-Kazooie',
          title: 'Banjo-Kazooie'
        }, {
          value: 'The Lord of the Rings',
          title: 'The Lord of the Rings'
        }, {
          value: 'WePlay',
          title: 'WePlay'
        }, {
          value: 'Star Trek',
          title: 'Star Trek'
        }, {
          value: 'Cyberpunk 2077',
          title: 'Cyberpunk 2077'
        }, {
          value: 'Spider Man',
          title: 'Spider Man'
        }, {
          value: 'The Little Mermaid',
          title: 'The Little Mermaid'
        }, {
          value: 'Defenders of the Earth',
          title: 'Defenders of the Earth'
        }, {
          value: 'My Hero Academia',
          title: 'My Hero Academia'
        }, {
          value: 'GRENDIZER',
          title: 'GRENDIZER'
        }, {
          value: 'Capcom',
          title: 'Capcom'
        }, {
          value: 'Hulk',
          title: 'Hulk'
        }, {
          value: 'Streetfighter',
          title: 'Streetfighter'
        }, {
          value: 'The Walking Dead',
          title: 'The Walking Dead'
        }, {
          value: 'Thanos',
          title: 'Thanos'
        }, {
          value: 'Iron Man',
          title: 'Iron Man'
        }, {
          value: 'Suicide Squad',
          title: 'Suicide Squad'
        }, {
          value: 'Virtus.Pro',
          title: 'Virtus.Pro'
        }, {
          value: 'Dark Project',
          title: 'Dark Project'
        }, {
          value: 'Fnatic',
          title: 'Fnatic'
        }, {
          value: 'Beauty and the Beast',
          title: 'Beauty and the Beast'
        }, {
          value: 'FragON',
          title: 'FragON'
        }
      ],
      brand: '',
      sorts: [],
      sort: '',
      checkboxInStore: true
    }
  },

  computed: {
    ...mapState('user', ['subscriptions', 'products']),
    ...mapGetters('user', ['isAuthorized']),
    ...mapGetters('global', ['getPlatformRemoteFeatures']),

    selectedProductId () {
      return this.$route.query.purchase
    },

    selectedProduct () {
      return this.selectedProductId && this.storeSubscriptions.find(
        subscription => subscription.id === parseInt(this.selectedProductId)
      )
    },

    marketplaceProductsPagesCount () {
      return Math.ceil(this.marketplaceProductsCount / this.marketplaceProductsPageSize)
    },

    starProducts () {
      return this.storeProducts
        .filter(({ type }) => type === 'stars')
        .sort((a, b) => a.price - b.price)
    },

    starProductsWeekly () {
      return this.starProducts
        .filter(star => star.extra_data?.duration === 7)
    },

    starProductsMonthly () {
      return this.starProducts
        .filter(star => star.extra_data?.duration === 30)
    },

    storeSubscriptions () {
      return this.storeProducts
        .filter(({ type }) => {
          return type.startsWith('subscription')
        })
    },

    proxies () {
      return this.storeProducts.filter(item => item.type === 'proxy')
    },

    freespins () {
      return this.storeProducts.filter(item => item.type === 'freebet').map((product) => {
        const isAvailable = !this.products?.find(
          p => p.product_id === product.id
        )

        return { ...product, isAvailable }
      }).filter(product => product.isAvailable)
    },

    activeTabIndex () {
      return this.tabs.findIndex(tab => tab.link === this.$route.path)
    },

    brandsSorted () {
      return [...this.brands].sort(function (a, b) {
        if (a.title < b.title) {
          return -1
        }
        if (a.title > b.title) {
          return 1
        }
        return 0
      })
    },

    allSubscriptions () {
      return this.storeSubscriptions
        .map((subscription) => {
          const isAvailable = !this.subscriptions?.find(
            sub => sub.type === subscription.type
          )

          return { ...subscription, isAvailable }
        })
        .filter(s => !s.is_hidden)
        .sort((a, b) => a.price - b.price)
    },

    subscriptionsFreeroll () {
      return this.allSubscriptions?.filter(subscription => subscription.type === 'subscription_freeroll')
    },

    subscriptionsFreerollWeekly () {
      return this.subscriptionsFreeroll.filter(subscription => subscription.extra_data?.duration === 7)
    },

    seasonSubscription () {
      return this.subscriptionsFreeroll.filter(subscription => subscription.end_date)?.[0]
    },

    trialSubscription () {
      return this.subscriptionsFreeroll.filter(subscription => subscription.extra_data?.trialDays)?.[0]
    },

    subscriptionsFreerollMonthly () {
      return this.subscriptionsFreeroll.filter(subscription => subscription.extra_data?.duration === 30)
    },

    starProduct () {
      return this.starProducts?.find(star => !star.extra_data?.price_in_coins)
    },

    starCoinsProduct () {
      return this.starProducts?.find(star => star.extra_data?.price_in_coins)
    }
  },

  mounted () {
    if (this.selectedProduct) {
      this.checkout(this.selectedProduct)
    }

    if (this.tabIs('marketplace')) {
      this.loadMarketplaceProducts()
    }
  },

  methods: {
    ...mapActions('modal', ['showModal']),
    ...mapActions('user', ['fetchProducts']),

    async loadMarketplaceProducts () {
      const { products, count } = (await StoreService.getMarketplaceProducts(this.$axios, this.marketplaceProductsPage, this.marketplaceProductsPageSize, this.productType, this.brand))?.data?.data
      this.marketplaceProducts = products
      this.marketplaceProductsCount = +count?.[0].count
    },

    onProductTypeChange (value) {
      this.productType = value
      this.marketplaceProductsPage = 1
      this.$nuxt.$loading.start()
      this.loadMarketplaceProducts()
      this.$nuxt.$loading.finish()
    },

    onBrandChange (value) {
      this.brand = value
      this.marketplaceProductsPage = 1
      this.$nuxt.$loading.start()
      this.loadMarketplaceProducts()
      this.$nuxt.$loading.finish()
    },

    openMarketplaceProduct (mpItem) {
      const name = mpItem.title.replace(/\//g, '-').replace(/ /g, '-').replace(/[,.&|]/g, '').replace(/[-]+/g, '-').toLowerCase()
      this.$router.push(this.localeLocation(`/product/${name}-${mpItem.id}`))
    },

    onMarketplaceProductsPageChange (value) {
      this.marketplaceProductsPage = value + 1
      this.$nuxt.$loading.start()
      this.loadMarketplaceProducts()
      this.$nuxt.$loading.finish()
    },

    onMarketplaceProductsPerPageChange (value) {
      this.marketplaceProductsPageSize = value
      this.marketplaceProductsPage = 1
      this.$nuxt.$loading.start()
      this.loadMarketplaceProducts()
      this.$nuxt.$loading.finish()
    },

    onTabChange ({ item }) {
      if (item.link) {
        this.$router.push(this.localeLocation(item.link))
      }
    },

    tabIs (name) {
      return this.$route.params.tab === 'all' || this.$route.params.tab === name
    },

    getLocalizedTitle (product) {
      if (this.$i18n.locale === 'ru') {
        return product.title
      }

      return this.getLocalizedParam(product, 'title')
    },

    getLocalizedParam (product, param) {
      let locale = this.$i18n.locale

      if (!product.extra_data?.text?.[locale]) {
        locale = 'en'
      }

      return product.extra_data?.text?.[locale]?.[param]
    },

    checkout (product) {
      if (!this.isAuthorized) {
        this.showModal({
          component: 'Auth',
          data: {
            mode: 'register',
            afterLogin: () => this.checkout(product)
          }
        })

        return
      }

      this.showModal({
        component: 'ModalCheckout',
        data: { product }
      })
    },

    onBuySubscriptionClickAction ({ product, isBuy, callback }) {
      this.onBuySubscriptionClick(product, isBuy, callback)
    },

    onBuySubscriptionClick (product, isBuy = false, callback = undefined) {
      if (!this.isAuthorized) {
        this.showModal({
          component: 'Auth',
          data: {
            mode: 'register',
            afterLogin: () => this.onBuySubscriptionClick(product, isBuy, callback)
          }
        })

        return
      }

      this.$gtag.event('buy_subscription_click', { product_id: product.id })

      if (isBuy) {
        return this.showModal({
          component: 'ModalCheckout',
          data: {
            product,
            callback
          }
        })
      }

      this.showModal({
        component: 'ModalProduct',
        data: {
          product,
          title: this.getLocalizedTitle(product),
          description: this.getLocalizedParam(product, 'long_description'),
          saleInfo: this.getLocalizedParam(product, 'sale_text'),
          callback
        }
      })
    },

    onButtonClick ({ coinsIndex } = {}) {
      if (coinsIndex >= 0) {
        const product = this.coins[coinsIndex]

        if (product) {
          this.checkout(product)
        }
      }
    },

    getSubcriptionButtonId (subscription, buttonType) {
      const id = `${subscription.type.replace('_', '-')}-${buttonType}`

      return id
    },

    mainImage (mpItem) {
      return mpItem?.images?.[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  max-width: calc(1500px - 65px);
  width: 100%;
  height: 64px;
  margin: 0 auto;

  &__item {
    position: relative;
    cursor: pointer;
    color: $blue-grey10;
    transition: all 0.3s;
    width: max-content;
    margin-right: 10px;

    &:hover {
      color: $white;
    }
  }
}

.tabs__item.--active .tabs__link {
  font-size: 18px;
  font-weight: 500;
  color: $blue-grey10;
  transform: translateY(0);
  line-height: 22px;

  &::after {
    position: absolute;
    top: 65px;
    left: 0;
    content: "";
    display: block;
    height: 2px;
    width: 100%;
    background-color: $amber60;
    border-radius: 20px;
  }
}

.store {
  position: relative;

  &__menu {
    display: flex;
    height: 64px;
    padding-left: 15px;
    color: $blue-grey10;
    background-color: $blue-grey70;
    border-bottom: 1px solid $blue-grey50;

    @media (min-width: 1500px) {
      margin-left: calc(-100vw / 2 + 1500px / 2 + 33px);
      margin-right: calc(-100vw / 2 + 1500px / 2);
      width: calc(100vw - 65px) !important;
    }
  }

  &__games {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px;
    margin-top: 28px;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    @media (min-width: $breakpointDesktopWide) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    }
  }

  &__game {
    position: relative;
    height: 156px;
    border-radius: 8px;
    color: $white;
    overflow: hidden;
    cursor: pointer;

    @media (min-width: $breakpointDesktopWide) {
      height: 184px;
    }

    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
    }

    &-title {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 18px 12px 12px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      background: linear-gradient(180deg, rgba(11, 20, 32, 0.00) 0%, #0B1420 100%);
    }
  }

  &__list {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 16px;
    margin-top: 16px;

    @media (min-width: $breakpointDesktop) {
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 32px;
      grid-row-gap: 32px;
      margin-top: 32px;
    }

    @media (min-width: $breakpointDesktopBig) {
      grid-template-columns: 1fr 1fr 1fr;
    }

    &-text {
      height: 164px;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;

      &-title {
        @include heading5;

        color: #fff;
        line-height: 130%;
      }

      &-subtitle {
        font-size: 16px;
        font-weight: 500;
        color: #9bb0cb;
        margin-top: 16px;
        line-height: 24px;
      }

      @media (max-width: $breakpointDesktopMedium) {
        grid-column: 1/3;
        height: auto;
        padding: 0;
      }

      @media (max-width: $breakpointMobile) {
        grid-column: auto;
      }
    }
  }

  &__product {
    background: $blue-grey70;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    padding: 24px 20px 20px;

    &:hover {
      box-shadow: 0 6px 10px -3px rgb(0 0 0 / 20%);
    }

    &-currency-block {
      display: flex;
      margin-right: 90px;
      flex-wrap: wrap;
    }

    .currency {
      font-weight: 600;
      font-size: 20px;
      color: #fff;
      min-height: 36px;
      align-items: flex-start;

      img {
        margin-right: 8px;
        position: relative;
        top: -3px;
      }

      strong {
        white-space: nowrap;
        height: 18px;
        line-height: 18px;
        padding-left: 3px;
        padding-right: 5px;
        font-weight: bold;
        padding-top: 3px;
      }

      span {
        color: $blue-grey10;
        height: 18px;
        line-height: 18px;
        padding-top: 3px;

        i {
          font-weight: bold;
          font-style: normal;
          color: #fff;
        }
      }
    }

    .button {
      margin-top: 12px;
    }

    &-price {
      @include heading6;

      margin-top: 18px;
      color: #fff;
      font-weight: 600;
    }
  }

  &__subscriptions {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;

    @media (min-width: 1100px) {
      grid-template-columns: 1fr 1fr;
    }
  }

  &__subscription {
    display: flex;
    height: unset;
    padding: 12px 0 0 24px;
    max-height: unset;

    &-duration {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #93a7c1;
    }

    &-info-block {
      max-width: 280px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 20px;
      padding-top: 12px;
    }

    &-image-block img {
      max-height: 240px;
      position: relative;
      z-index: 1;
      bottom: -54px;
    }

    &-title {
      @include heading4;

      color: $white;
    }

    &-description {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #9bb0cb;
      margin-top: 12px;
    }

    &-list {
      @include body;

      color: $white;
      position: relative;
      left: 20px;
      margin-top: 12px;

      li {
        span {
          color: $yellow70;
        }

        &::before {
          content: "\2022";
          color: $white;
          font-weight: bold;
          display: inline-block;
          width: 1em;
          margin-left: -1em;
        }
      }
    }

    &-price {
      display: flex;
      flex-direction: column;

      .currency img {
        top: 0;
      }

      .store__product-price {
        margin-right: 20px;
      }
    }

    &-buttons {
      display: flex;
      z-index: 4;

      .button:not(:last-child) {
        margin-right: 16px;
      }
    }

    &-line {
      position: absolute;
      width: 88px;
      height: 300px;
      right: 32px;
      top: -100px;
      background: #1183f3;
      transform: rotate(-45deg);
    }

    @media (max-width: $breakpointTablet) {
      max-width: unset;
      max-height: unset;
      padding: 16px 0 0 16px;

      &-info-block {
        max-width: unset;
        padding: 0;
      }

      &-image-block {
        margin-right: 16px;
        margin-left: 8px;

        img {
          border-radius: 8px;
          max-width: 169px;
        }
      }

      &-title {
        @include heading3;

        margin-top: 16px;
      }

      &-price {
        margin-bottom: 16px;
      }

      &-line {
        display: none;
      }
    }

    @media (max-width: $breakpointMobile) {
      flex-direction: column-reverse;
      padding: 16px 16px 0;

      &-buttons {
        flex-direction: column;

        .button {
          width: 100%;
        }
      }

      &-image-block {
        margin: 0 0 12px;

        img {
          max-width: 100%;
          max-height: unset;
          bottom: 0;
        }
      }

      &-title {
        margin-top: 4px;
      }
    }
  }

  .breadcrumbs {
    position: absolute;
    left: 40px;
    top: 32px;
    z-index: 2;

    @media (max-width: $breakpointTablet) {
      left: 24px;
      top: 24px;
    }

    @media (max-width: $breakpointMobile) {
      left: 16px;
      top: 16px;
    }
  }

  &__marketplace {
    margin-top: 16px;

    &-filters {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;
      margin-bottom: 20px;

      @media (min-width: $breakpointTablet) {
        grid-template-columns: 1fr 1fr;
      }

      @media (min-width: $breakpointDesktopWide) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 14px;
      }
    }

    &-filter {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 16px;
      background: $blue-grey60;
      color: $white;
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      border-radius: 10px;
      min-height: 48px;
    }

    &-list {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;

      @media (min-width: $breakpointTablet) {
        grid-template-columns: 1fr 1fr;
      }

      @media (min-width: $breakpointDesktopWide) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 14px;
      }
    }

    &-product {
      display: grid;
      grid-template-columns: 120px 1fr;
      grid-gap: 16px;
      padding: 16px;
      border-radius: 16px;
      background-color: $blue-grey60;
      cursor: pointer;

      &-image {
        height: 120px;
        width: 120px;
        border-radius: 16px;
        background-color: $white;
      }

      &-body {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: max-content 1fr max-content;
        grid-gap: 4px;
        padding: 0;

        &-title {
          font-size: 12px;
          line-height: 100%;
          font-weight: 400;
          color: $white;
          padding-right: 16px;
        }

        &-brand {
          font-size: 10px;
          font-weight: 500;
          line-height: 14px;
          letter-spacing: 0.2px;
          text-transform: uppercase;
          color: $blue-grey10;
        }

        &-right {
          justify-content: flex-end;
        }

        &-price {
          display: block;
          font-size: 12px;
          line-height: 120%;
          font-weight: 500;
          color: $white;
        }
      }

    }
  }
}

.old {
  text-decoration: line-through;
  font-weight: 400;
  color: #9bb0cb;
}
</style>
